import { Module } from '../Module';

// This allows the href property to be a function that returns a string
Module.instance().directive('tbHref', <any[]>[
  () => {
    return {
      restrict: 'A',
      link: (scope: ng.IScope, _element: JQuery, attr: ng.IAttributes) => {
        scope.$watch(attr['tbHref'], (href: string) => {
          attr.$set('href', href);
        });
      }
    };
  }
]);
